module.exports = __webpack_public_path__ + "static/media/ILAT-logo-blanco.fa04c226.svg";